import numeral from 'numeral';

import { ISO_COUNTRY } from '~constants/environment';

import { LOCALE_DATA } from '../config/numeral';

LOCALE_DATA.forEach(({ code, locale }) => numeral.register('locale', code, locale));

numeral.locale(`es-${ISO_COUNTRY}`);
